import objectAssign from 'object-assign';


export function discoverFeed( state = { 
	interestGroup: [],
	ofTheWeek: {},
	featured: [],
	missed: {},
	latest: [],
	usedArticles: [],
	interests: [],
}, action ) {

	switch( action.type ) {

		default:
			return state;

	}
	
}



// WEBPACK FOOTER //
// ./src/js/reducers/discoverFeed.js